import { render, staticRenderFns } from "./PosicaoFiscal.vue?vue&type=template&id=083051dd&"
import script from "./PosicaoFiscal.vue?vue&type=script&lang=js&"
export * from "./PosicaoFiscal.vue?vue&type=script&lang=js&"
import style0 from "./PosicaoFiscal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports